import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const earlyDeparturePolicyApiConfig = {
  getEarlyDeparturePolicies: {
    key: "getEarlyDeparturePolicies",
    url: "/api/v1/early-departure-policies",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },
  getDeletedEarlyDeparturePolicies: {
    key: "getDeletedEarlyDeparturePolicies",
    url: "/api/v1/early-departure-policies/deleted",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },
  getEarlyDeparturePolicyById: {
    key: "getEarlyDeparturePolicyById",
    url: (data) => `/api/v1/early-departure-policies/${data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },
  createEarlyDeparturePolicy: {
    key: "createEarlyDeparturePolicy",
    url: "/api/v1/early-departure-policies",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getEarlyDeparturePolicies"],
      onSuccessMessage: "Early departure policy created successfully",
      onErrorMessage: "Failed to create early departure policy",
    },
  },
  updateEarlyDeparturePolicy: {
    key: "updateEarlyDeparturePolicy",
    url: (data) => `/api/v1/early-departure-policies/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getEarlyDeparturePolicies", "getEarlyDeparturePolicyById"],
      onSuccessMessage: "Early departure policy updated successfully",
      onErrorMessage: "Failed to update early departure policy",
    },
  },
  softDeleteEarlyDeparturePolicy: {
    key: "softDeleteEarlyDeparturePolicy",
    url: (data) => `/api/v1/early-departure-policies/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getEarlyDeparturePolicies"],
      onSuccessMessage: "Early departure policy deleted successfully",
      onErrorMessage: "Failed to delete early departure policy",
    },
  },
  restoreEarlyDeparturePolicy: {
    key: "restoreEarlyDeparturePolicy",
    url: (data) => `/api/v1/early-departure-policies/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getEarlyDeparturePolicies"],
      onSuccessMessage: "Early departure policy restored successfully",
      onErrorMessage: "Failed to restore early departure policy",
    },
  },
};
